module.exports = __webpack_public_path__ + "img/money.8d8cef74.svg";